import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core';

import { observer, inject } from 'mobx-react';

@inject('videoStore')
@observer
class AddDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {videoUrl: ''};
  }

  handleUrlChange = (event) => {
    this.setState({videoUrl: event.target.value}, () => { console.log(this.state.videoUrl) });
  }

  handleAddVideo = () => {
    if (this.state.videoUrl.length > 0) {
      this.props.videoStore.pushVideo(this.state.videoUrl);
      this.props.videoStore.videos;
    }
    this.setState({videoUrl: ''});
  }

  render() {
    const store = this.props.videoStore;

    return (
      <Dialog
        open={store.addDialogOpen}
        onClose={store.handleAddClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Add Video...</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Add a Video link from YouTube, Twitch, Vimeo, DailyMotion, etc.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="link"
            label="Video Link"
            type="url"
            onChange={this.handleUrlChange}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={store.handleAddClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={this.handleAddVideo} variant="contained" color="secondary">
            Add
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default AddDialog;


// WEBPACK FOOTER //
// ./src/components/AddDialog.js